import { create } from 'zustand'

export type DiagramRestoreOriginReason =
  | 'ARCHIVE_ORIGIN_MISSING'
  | 'ARCHIVE_ORIGIN_ARCHIVED'
  | 'ARCHIVE_ORIGIN_UNAVAILABLE'

export type DiagramRestoreOriginDetails = {
  reason: DiagramRestoreOriginReason
  diagramIds: string[]
  originFolderId: string | null
  originFolderName: string | null
}

type RestoreDiagramOriginState = {
  open: boolean
  details: DiagramRestoreOriginDetails | null
  openWith: (details: DiagramRestoreOriginDetails) => void
  close: () => void
}

export const useRestoreDiagramOriginDialog = create<RestoreDiagramOriginState>((set) => ({
  open: false,
  details: null,
  openWith: (details) => set({ open: true, details }),
  close: () => set({ open: false, details: null }),
}))
